import React from 'react';
import { Link } from 'react-router-dom';

function ShippingPolicyTag() {
  return (
    <Link
      to="/shipping-policy"
      target="_blank"
      className="mt-10"
      style={{ width: '105px', color: '#4eb45e', textDecoration: 'underline', cursor: 'pointer' }}
    >
      Shipping Policy
    </Link>
  );
}

export default React.memo(ShippingPolicyTag);
